import {useCallback, useEffect} from 'react';
import {t} from 'i18next';
import {Box, Link, Typography} from '@mui/material';
import AurButton from '../../../../common/aur-button/AurButton';
import {AurSwitch} from '../../../../common/aur-switch/AurSwitch';
import AurEcaBanner from '../../../../common/aur-eca-banner/AurEcaBanner';
import {ReactComponent as ChevRightIcon} from '../../../../../assests/svg/chev_right_white.svg';

const stringPath = 'projectCreation.creation.genAiInvestigate.';

interface Props {
  onSaveNContinue: () => void;
  onAIToggleButton: (data: boolean) => void;
  IsAIInvestigateEnabled: boolean;
}
const LeverageGenAI: React.FC<Props> = ({
  onSaveNContinue,
  onAIToggleButton,
  IsAIInvestigateEnabled,
}) => {
  // const [videoUrl, setVideoUrl] = useState<string>();
  // const [thumbnailUrl, setThumbnailUrl] = useState<string>();

  // const {showToast} = useToast();

  // const getVideo = useCallback(async () => {
  //   try {
  //     const videoBlob = await getProjectMarketingVideo();
  //     if (!videoBlob) return;

  //     const objectUrl = URL.createObjectURL(videoBlob);
  //     setVideoUrl(objectUrl);
  //   } catch (error: unknown) {
  //     const err = error as AxiosError;
  //     showErrorToast(showToast, err, 'right');
  //   }
  // }, [showToast]);

  // const getVideoThumbnail = useCallback(async () => {
  //   try {
  //     const videoBlob = await getProjectMarketingVideoThumbnail();
  //     if (!videoBlob) return;

  //     const objectUrl = URL.createObjectURL(videoBlob);
  //     setThumbnailUrl(objectUrl);
  //   } catch (error: unknown) {
  //     const err = error as AxiosError;
  //     showErrorToast(showToast, err, 'right');
  //   }
  // }, [showToast]);

  useEffect(() => {
    window.scrollTo(0, 0);
    // getVideoThumbnail();
    // getVideo();
  }, []);

  const onSaveNContinueClick = useCallback(() => {
    onSaveNContinue();
  }, [onSaveNContinue]);

  return (
    <Box className="ai-investigate-container">
      <Box className="ai-investigate-main">
        <Box className="ai-investigate-left">
          <AurEcaBanner
            enableNavigation={false}
            bannerText={t(stringPath + 'aiInvestigate')}
            betaTagText={t(stringPath + 'beta')}
          />

          <Box className="ai-investigate-content">
            <Typography className="typo-text display2_size text-color heading">
              {t(stringPath + 'heading')}
            </Typography>
            <Typography className="typo-text body1_size text-color sub-text">
              {t(stringPath + 'subText1')}{' '}
              <Link
                className="typo-text subhead3_size learn-more-link"
                tabIndex={0}
                role="link"
              >
                {t(stringPath + 'subText2')}
              </Link>
            </Typography>
            <Typography className="typo-text headline3_size gradient-text">
              {t(stringPath + 'subText3')}
            </Typography>
            <Box className="switch-container">
              {' '}
              <AurSwitch
                checked={IsAIInvestigateEnabled}
                onChange={(e) => {
                  onAIToggleButton(e.target.checked);
                }}
                dataTestId="enable-gen-ai-switch"
              />
              <Typography className="typo-text subhead3_size text-color">
                {IsAIInvestigateEnabled
                  ? t(stringPath + 'disable')
                  : t(stringPath + 'enable')}
              </Typography>
              <Typography className="typo-text body1_size text-color">
                {t(stringPath + 'additonalCharges')}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box className="ai-investigate-right">
          {/* {videoUrl && <AurVideoPlayer src={videoUrl} poster={thumbnailUrl} />} */}
        </Box>
      </Box>
      <Box className="footer-button-container">
        <AurButton
          label={t(stringPath + 'saveAndContine')}
          type="continue"
          size="Large"
          dataTestId="saveAndContinue"
          classNames="save-button"
          endIcon={<ChevRightIcon />}
          onClick={onSaveNContinueClick}
        />
      </Box>
    </Box>
  );
};

export default LeverageGenAI;
